import React from 'react'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min'
import { useImpersonateUser } from '../../../../../../context/auth.context'
import { useApiListLoginUser } from '../../../../../../api-new/state/content'
import { Menu, MenuAdd, MenuEdit, MenuItem, MenuRemove } from '../../../../../../shared/menu/menu'
import { IconImpersonate, IconOrganization } from '../../../../../../shared/icon/icon'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { useRoleSysLogin } from '../../../../../../role/hook/role-sys'
import { TableAgClient } from '../../../../../../shared/table-builder/table-ag-client'
import { ColumnFormat, ColumnMenu, ColumnText } from '../../../../../../shared/table-builder/table-columns'
import { impersonationError, impersonationUrl } from './impersonate-link'
import { ErrorReference } from '../../../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../../../shared/error/use-error-line'

export function OrganizationUserList() {
  const { loginID } = useParamsInt()

  const { url } = useRouteMatch()

  const impersonateUser = useImpersonateUser()

  const apiListLoginUser = useApiListLoginUser()

  const roleSysLogin = useRoleSysLogin()

  const handleReady = () => apiListLoginUser.get(`${loginID}/login`)
  const handleDestroyed = () => apiListLoginUser.init()

  const [impersonateFailed, impersonateFailure, setImpersonateFailed] = useErrorLine()

  // Starting an impersonation ends this admin's previous one (server-side)
  // and answers a one-time code the new tab redeems for the session.
  const handleImpersonate = async item => {
    setImpersonateFailed(null)
    try {
      const handoff = await impersonateUser(item.organizationID, item.id)
      window.open(impersonationUrl(process.env.REACT_APP_SITE, handoff.code), '_blank', 'noopener, noreferrer')
    } catch (e) {
      setImpersonateFailed(impersonationError(e), e)
    }
  }

  const HeaderMenu = () =>
    <Menu>
      <MenuAdd text="add login to org" to={`${url}/add`} show />
    </Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconOrganization} text="Organizations">
        <CardFullHeightScrollY title="organizations" height={500} HeaderMenu={HeaderMenu}>
          {impersonateFailed && <div className="alert alert-danger py-2 small" role="alert">{impersonateFailed}<ErrorReference error={impersonateFailure} /></div>}
          <TableAgClient apiList={apiListLoginUser} hideFloatingFilter onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="organizationName" header="organization" />
            {/* Holds the organization's owner role (content GET /login-user/:id/login
                isOwner). "Yes" or blank: a server without the field shows blank, not "No". */}
            <ColumnFormat field="isOwner" header="owner" render={row => (row.value ? 'Yes' : '')} />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuItem Icon={IconImpersonate} text="Impersonate User" onClick={() => handleImpersonate(row)} show />
                  <MenuEdit text="Edit User" to={`/admin/login/list/edit/${loginID}/organizations/edit/${row.id}`} show={roleSysLogin.accessUpdate} />
                  {/* A soft delete; the last owner of an organization is refused (409). */}
                  <MenuRemove text="Remove from organization" to={`${url}/edit/${row.id}/delete/${row.id}`} show={roleSysLogin.accessDelete} />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
